/** Re-run CTM so newly mounted tel: links (e.g. BelowFold lazy sections) get number swap. */
export const runCtmWhenReady = () => {
  if (typeof window === 'undefined') return;

  const startedAt = Date.now();
  const maxAttempts = 12;

  const tryRun = (attempt = 0) => {
    if (window.__ctm?.main?.runNow) {
      window.__ctm.main.runNow();
      return;
    }

    if (attempt >= maxAttempts || Date.now() - startedAt > 7000) return;

    setTimeout(() => tryRun(attempt + 1), 250);
  };

  tryRun();
};
